import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { Stall } from '@/api/types';
import { LivePill } from './LivePill';

interface Props {
  stall: Stall;
  distanceKm?: number;
}

export function StallCard({ stall, distanceKm }: Props) {
  const { i18n } = useTranslation();
  const isTh = i18n.language.startsWith('th');
  const name = isTh ? stall.name_th : stall.name_en;
  const hood = isTh ? stall.neighborhood_th : stall.neighborhood_en;
  const dishes = (isTh ? stall.dishes_th : stall.dishes_en).join(' · ');
  return (
    <Link
      to={`/stall/${encodeURIComponent(stall.id)}`}
      className="grid grid-cols-[56px_1fr_auto] items-center gap-3 rounded-md border border-[color:var(--border)] bg-[color:var(--surface)] p-3 text-ink no-underline transition hover:border-soi-400 hover:bg-soi-50"
    >
      <div className="grid h-14 w-14 place-items-center rounded-md bg-soi-100 text-2xl">
        {stall.photo_url ? (
          <img src={stall.photo_url} alt="" className="h-full w-full rounded-md object-cover" />
        ) : (
          <span aria-hidden="true">🍳</span>
        )}
      </div>
      <div className="min-w-0">
        <div className="truncate text-base font-bold">{name}</div>
        <div className="text-xs text-ink-muted">{hood} · {dishes}</div>
        <div className="text-[11px] text-ink-muted">
          ★ {stall.rating.toFixed(1)} · {stall.reviews}
        </div>
      </div>
      <div className="flex flex-col items-end gap-1">
        <LivePill status={stall.status} justOpened={stall.just_opened} />
        {typeof distanceKm === 'number' && (
          <span className="tabular text-xs text-ink-muted">{distanceKm.toFixed(1)} km</span>
        )}
      </div>
    </Link>
  );
}
